angular.module 'app'
.controller 'LayoutTestCtrl', ($scope, $http, $stateParams, $state, config, Storage) ->

  $scope.permission = Storage.get('user_permission')
